import React, { useContext, useEffect, useState } from "react";
import { allProductForStoreApi } from "../../../Apis/ProductApi";
import { UserAuthContext } from "../../../App";

const MyStoreProducts = ({ addedTop, setAddedTop, isVisible, setIsVisible }) => {

  const {userUid} = useContext(UserAuthContext);
  const [allProductsData, setAllProductData] = useState([]);
  const [liked, setLiked] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  const [topProductsArray, setTopProductsArray] = useState([]);
  const [likedProductIDs, setLikedProductIDs] = useState([]);


  const getProducts = async ()=>{
    try{
      const response = await allProductForStoreApi(userUid?.currentUser?.uid);
      if(response && response?.products){
        setAllProductData(response?.products);
        setIsVisible(Array(response.products.length).fill(false));
        setTopProducts(Array(response.products.length).fill(false));
      }
    }catch(error){
      console.log("Failed to fetch the product details", error);
    }
  }

  useEffect(()=>{
      getProducts();
  },[userUid]);

  // const products = Array.from({ length: 16 }, (_, index) => ({
  //   id: index,
  //   name: `Apple iPhone 13 Pro Max (128 GB)`,
  //   price: "₹ 50,000",
  //   image: require("../../../assets/SellerDashboard/MyStore/MyStoreProducts/image 299.jpg"),
  // }));

  // Initialize the liked state based on the index (even indices start as false, odd indices start as true)
  // const initialLikedState = products.map((_, index) => index % 0);
  // const [liked, setLiked] = useState(initialLikedState);
  // const [topProducts, setTopProducts] = useState(
  //   Array(products.length).fill(false)
  // );

  // const toggleLike = (index) => {
  //   const newLiked = [...liked];
  //   newLiked[index] = !newLiked[index];
  //   setLiked(newLiked);
  // };

  const toggleLike = (index, productID) => {
    const newLiked = [...liked];
    newLiked[index] = !newLiked[index];
    setLiked(newLiked);

    const newLikedProductIDs = newLiked[index]
      ? [...likedProductIDs, productID]
      : likedProductIDs.filter(id => id !== productID);

    setLikedProductIDs(newLikedProductIDs);
    setIsVisible(newLikedProductIDs);
  };

  // const toggleTopProduct = (index, productID) => {
  //   // console.log(index, "selected index");
  //   // console.log(topProductsArray, "before top Products");
  //   // console.log(!topProductsArray.includes(index));
  //   if (!topProductsArray.includes(index)) {
  //     if (topProductsArray.length < 2) {
  //       // topProductsArray.push(index);
  //       setTopProductsArray([...topProductsArray, index]);
  //       console.log(topProductsArray, "after top Products");
  //       const newTopProducts = [...topProducts];
  //       newTopProducts[index] = !newTopProducts[index];
  //       setTopProducts(newTopProducts);
  //       setAddedTop([...addedTop, productID]);
  //     }
  //   } else {
  //     setTopProductsArray((oldValues) => {
  //       return oldValues.filter((element) => element !== index);
  //     });
  //     // console.log(topProductsArray, "after top Products");
  //     const newTopProducts = [...topProducts];
  //     newTopProducts[index] = !newTopProducts[index];
  //     setTopProducts(newTopProducts);
  //     setAddedTop(addedTop.filter((id) => id !== productID));
  //   };
  // };

  const toggleTopProduct = (index, productID) => {
    const newTopProducts = [...topProducts];
    if (newTopProducts[index]) {
      // Remove from top products
      newTopProducts[index] = false;
      setTopProductsArray(topProductsArray.filter(i => i !== index));
      setAddedTop(addedTop.filter(id => id !== productID));
    } else {
      // Add to top products if less than 2
      if (topProductsArray.length < 2) {
        newTopProducts[index] = true;
        setTopProductsArray([...topProductsArray, index]);
        setAddedTop([...addedTop, productID]);
      }
    }
    setTopProducts(newTopProducts);
  };

  return (
    <div className="w-[891px] h-[620px] rounded-b-[5px] bg-white flex flex-col">
      <div className="flex flex-row justify-between mt-[14px]">
        <h3 className="w-[85px] h-[21px] text-black font-semibold text-[14px] text-start">
          All Products
        </h3>
        <p className="w-[150px] h-[21px] text-black font-semibold text-[14px] text-end">
          Top Products :{" "}
          <span className="text-[14px] font-semibold text-[#FF6300]">
            {addedTop.length}/2
          </span>
        </p>
      </div>

      <div className="w-full h-full mt-[21px] pt-[3px] flex flex-wrap gap-[18px] overflow-y-scroll pb-[5px]">
        {allProductsData.map((products, index) => (
          <div
            key={products.productID}
            className="w-[209px] h-[340px] bg-white rounded-[10px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]"
          >
            <div className="w-full h-[155px] bg-[#F8F8F8] flex items-start justify-between rounded-t-[10px] py-[17px] px-[15px] flex-row">
              <div className="w-[125px] h-[120px] flex items-center justify-end">
                <img src={products?.images[0]} alt="" className="w-[70px] h-[87px]" />
              </div>

              <button
                className={`w-[32px] h-[32px] bg-white rounded-[5px] drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)] flex items-center justify-center ${
                  liked[index] ? "" : "text-[#9E9E9E]"
                }`}
                onClick={() => toggleLike(index, products?.productID)}
              >
                {liked[index] ? (
                  <>
                    <div className="text-white bg-[#FF6300] flex items-center justify-center w-[32px] h-[32px] rounded-[5px]">
                      <svg
                        width="21"
                        height="20"
                        viewBox="0 0 21 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10.5031 4.16797C6.90312 4.16797 3.83646 6.94297 2.11979 9.54297L1.82812 10.0013L2.12813 10.4596C3.83646 13.0596 6.90312 15.8346 10.5031 15.8346C14.1031 15.8346 17.1698 13.0596 18.8865 10.4596L19.1865 10.0013L18.8865 9.54297C17.1698 6.94297 14.1031 4.16797 10.5031 4.16797ZM10.5031 14.168C7.76979 14.168 5.32812 12.093 3.83646 10.0013C5.33646 7.90964 7.77813 5.83464 10.5031 5.83464C13.2281 5.83464 15.6781 7.90964 17.1698 10.0013C15.6781 12.093 13.2365 14.168 10.5031 14.168Z"
                          fill="white"
                        />
                        <path
                          d="M10.5052 6.66797C9.84594 6.66797 9.20147 6.86347 8.65331 7.22974C8.10515 7.59601 7.6779 8.1166 7.42561 8.72569C7.17332 9.33478 7.10731 10.005 7.23593 10.6516C7.36454 11.2982 7.68201 11.8921 8.14819 12.3583C8.61436 12.8245 9.20831 13.142 9.85491 13.2706C10.5015 13.3992 11.1717 13.3332 11.7808 13.0809C12.3899 12.8286 12.9105 12.4014 13.2768 11.8532C13.643 11.305 13.8385 10.6606 13.8385 10.0013C13.8385 9.11725 13.4874 8.2694 12.8622 7.64428C12.2371 7.01916 11.3893 6.66797 10.5052 6.66797ZM10.5052 11.668C10.1756 11.668 9.85334 11.5702 9.57926 11.3871C9.30518 11.2039 9.09156 10.9437 8.96541 10.6391C8.83926 10.3346 8.80626 9.99945 8.87057 9.67615C8.93488 9.35285 9.09361 9.05588 9.3267 8.82279C9.55979 8.5897 9.85676 8.43097 10.1801 8.36666C10.5034 8.30235 10.8385 8.33536 11.143 8.4615C11.4476 8.58765 11.7079 8.80127 11.891 9.07535C12.0741 9.34943 12.1719 9.67167 12.1719 10.0013C12.1719 10.4433 11.9963 10.8673 11.6837 11.1798C11.3712 11.4924 10.9472 11.668 10.5052 11.668Z"
                          fill="white"
                        />
                      </svg>
                    </div>

                    {/* <div>H</div> */}
                  </>
                ) : (
                  <>
                    <svg
                      width="19"
                      height="18"
                      viewBox="0 0 19 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0_1570_17102)">
                        <path
                          d="M8.37762 7.94141C8.08074 8.22277 7.91399 8.60434 7.91406 9.00217C7.91414 9.40001 8.08103 9.78152 8.37802 10.0628C8.67501 10.344 9.07778 10.502 9.49772 10.5019C9.91765 10.5019 10.3204 10.3438 10.6172 10.0624"
                          stroke="#9E9E9E"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M13.2058 12.5048C12.0953 13.163 10.8099 13.5082 9.5 13.5C6.65 13.5 4.275 12 2.375 9.00002C3.382 7.41002 4.522 6.24152 5.795 5.49452M8.05917 4.63502C8.5334 4.54407 9.01614 4.49884 9.5 4.50002C12.35 4.50002 14.725 6.00002 16.625 9.00002C16.0978 9.83252 15.5333 10.5503 14.9324 11.1525"
                          stroke="#9E9E9E"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M2.375 2.25L16.625 15.75"
                          stroke="#9E9E9E"
                          stroke-width="1.83333"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1570_17102">
                          <rect width="19" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </>
                )}
              </button>
            </div>

            <div className="flex flex-col px-[13px] pt-[9px] pb-[15px] w-full h-[185px] justify-between">
              <p className="w-[180px] h-[49px] font-semibold text-[14px] leading-[25px] text-start">
                {products?.productTitle.slice(0,48)}...
              </p>

              <p className="w-full h-[24px] text-[#FF6300] font-semibold mt-[3px] text-start">
                {products?.maxPrice}
              </p>
              <div className="flex flex-col gap-2">
                <button
                  className={`w-[182px] h-[38px] rounded-[5px] flex flex-row items-center justify-center font-semibold text-[12px] ${
                    topProducts[index]
                      ? "bg-white text-black border"
                      : topProductsArray.length < 2
                      ? "bg-[#FF6300] text-white"
                      : "bg-[#D9D9D9] text-white cursor-not-allowed"
                  }`}
                  onClick={() => toggleTopProduct(index, products?.productID)}
                >
                  {topProducts[index]
                    ? "Remove from Top Products"
                    : "Add to Top Products"}
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyStoreProducts;
